import React, { useState } from 'react'

const AppContext = React.createContext([{}, () => { }])

const AppProvider = (props) => {
  const [state, setState] = useState({
    positions: {
      one: [0, -0.49, 4],
      two: [2, -0.52, -4],
      thre: [-4, -0.53, -8]
    },
    // rotation: {
    //   one: [0, -3.4, 0],
    //   two: [0, -2.9, 0],
    //   thre: [0, -2.3, 0]
    // },
    scale: {
      one: 1,
      two: 1,
      thre: 1
    },
    visibility: {
      one: 'visible',
      two: 'visible',
      thre: 'visible'
    },
    open: false,
    shadows: 'accumulative',
    number: null,
    camera: [35.0379520629086, 3.501758829609992, -20.38652322621527],
    rotation: [0, 0, 0]
  })
  return <AppContext.Provider value={[state, setState]}>{props.children}</AppContext.Provider>
}

export { AppContext, AppProvider }
